import styled, { css } from 'styled-components';

export const defaultBarMixin = css`
  align-items: center;
  display: flex;
  flex: 1;
  justify-content: space-between;
  min-height: 5rem;
  padding: 0 2rem;
`;

export const BarSectionElement = styled.div`
  display: flex;
`;

export const BarItemElement = styled.div`
  display: flex;
  align-items: center;
  margin-right: 3.5rem;

  :last-child {
    margin-right: 0;
  }
`;

export const BarBlockElement = styled.div`
  display: flex;
  padding: 15px 20px;
  justify-content: center;
  &.disabled {
    pointer-events: none;
    * {
      color: ${({ theme }) => theme.vars.newColor.darkGS3} !important;
    }
  }
`;
